// extracted by mini-css-extract-plugin
export default {"watchDemo":"xOv9Ttp0","dialog":"Je9kUi4c","header":"Zg4IxLbZ","content":"XjzQVHJx","videoContainer":"IlZbx9jT"};